import { GenericService } from '@/services/api/generic.service';
export class MeniconSurveyResultsService extends GenericService {
    constructor(patientId) {
        super(`menicon/v1/patients/${patientId}/virtual-doctor/survey-results`);
    }
}
